import { routes } from "@/routes/utils";
import { FileText, Gauge, UserRound, UsersRound } from "lucide-react";

export const admin_menus = [
  {
    to: `/${routes.admin}/${routes.dashboard}`,
    title: "Dashboard",
    icon: Gauge,
  },
  {
    to: `/${routes.admin}/${routes.masterData}`,
    title: "Master Data",
    icon: FileText,
    children: [
      {
        to: `/${routes.admin}/${routes.masterData}/${routes.category}`,
        title: "Project Category",
      },
      {
        to: `/${routes.admin}/${routes.masterData}/${routes.role}`,
        title: "Role",
      },
    ],
  },
  {
    to: `/${routes.admin}/${routes.employeeMgmt}`,
    title: "Employee Management",
    icon: UsersRound,
  },
  {
    to: `/${routes.admin}/${routes.projectOverview}`,
    title: "Project Overview",
    icon: UsersRound,
  },
  {
    to: `/${routes.admin}/${routes.clientMgmt}`,
    title: "Client Management",
    icon: UserRound,
  },
];

export const pm_menus = [
  {
    to: `/${routes.pm}/${routes.dashboard}`,
    title: "Dashboard",
    icon: Gauge,
  },
  {
    to: `/${routes.pm}/${routes.projectOverview}`,
    title: "Project Overview",
    icon: UsersRound,
  },
];
